
define('app/board/boardApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/collections/productCollection',
	'app/board/collections/chatMessageCollection',
	'app/board/collections/pickSummaryCollection',
	'app/board/collections/pickCollection',
	'app/board/collections/queueCollection',
	'app/board/collections/rosterPositionCollection',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productModel',
	'app/board/models/draftStatusModel',
	'app/board/models/draftOptionsModel',
	'app/board/models/positionColorsModel',
	'app/board/models/timerModel',
	'app/board/models/pickModel',
	'app/board/models/pickSummaryModel',
	'app/board/views/chatView',
	'app/board/views/draftBoardView',
	'app/board/views/teamRosterView',
	'app/board/views/selectPlayerView',
	'app/board/views/optionView',
	'app/board/views/deletePickView',
	'app/board/views/shareView',
	'app/board/views/headerView',
	'app/board/views/draftViewModeView',
	'app/board/views/playerRanksView',
	'app/board/views/queueView',
	'app/board/views/draftInfoView',
	'app/board/util/playerList',
	'module',	
	
	//Shims
	'jquery.select2',
	'jquery.getUrlParam',
	'pushstream'
], function(
		$, 
		_, 
		Backbone, 
		KnownUtil, 
		ProductCollection,
		ChatMessageCollection,
		PickSummaryCollection,
		PickCollection,
		QueueCollection,
		RosterPositionCollection,
		UserModel, 
		LeagueInstanceModel,
		ProductModel,
		DraftStatusModel,
		DraftOptionsModel,
		PositionColorsModel,
		TimerModel,
		PickModel,
		PickSummaryModel,
		ChatView,
		DraftBoardView,
		TeamRosterView,
		SelectPlayerView,
		OptionView,
		DeletePickView,
		ShareView,
		HeaderView,
		DraftViewModeView,
		PlayerRanksView,
		QueueView,
		DraftInfoView,
		PlayerList,
		module){
	
	var userModel = {};
	var lgInstanceModel = {};
	var prodModel = {};
	var draftStatusModel = {};
	var draftOptionsModel = {};
	var positionColorsModel = {};
	var timerModel = {};
	var chatMessageCollection = {};
	var pickSummaryCollection = {};
	var pickCollection = {};
	var queueCollection = {};
	var rosterPositionCollection = null;
	var prodConfig = {};
	var playerList = {};
	var sportsTeams = {};
	var serverTimeDiff = {};
	var serverTimeDiffCount = 0;
	var pushstream = {};
	var refreshWait = false;
	var reconnectWait = false;
	var headerView = null;
	
	var updateOnlineStatus = function() {
		$.ajax({
			headers : {
				"Content-Type" : "application/json",
				"Accept" : "application/json"
			},
			url : "/draftapp/leagues/" + lgInstanceModel.get('leagueId') + "/league-instances/" + lgInstanceModel.get('id') + "/online-status",
			type : "GET",
			dataType : "json",
			success : function(data, status) {
				if(userModel.get('userName') != data.userName){
					userModel.set({userName: data.userName});
				}
				
				//Update the online status of all the users
				_.each(data.userOnlineStatusMap, function(statusObj, name){
					lgInstanceModel.getLeagueUser(name).set({
						timeSinceActivity : statusObj.timeSinceActivity,
						activityTime : statusObj.activityTime
					});
				}, this);
			}});
	};
	
	var serverCheckin = function() {
		if(!refreshWait){
			updateOnlineStatus();
		}
	};
	
	var updatePicks = function() {
		pickCollection.fetch({success: function() {
			syncPicks();				
		}});
	};
	
	var calcAllowedPositions = function(fantTeamId) {
		var posMap = draftStatusModel.get('teamPosMap')[fantTeamId];
		var minRemaining = 0;
		var nonMaxedOutPos = {};
		var maxedOutPos = {};
		var minNotMetPos = {};
		
		//loop through all positions and calc the min remaining picks
		lgInstanceModel.get('leaguePositions').each(function(lgPos) {
			var count = 0;
			if(posMap[lgPos.get('id')] != null){
				count = posMap[lgPos.get('id')].length;
			}
			
			//See if count is below min, then add lgPos positions
			if(count < lgPos.get('min')){
				minRemaining += lgPos.get('min') - count;
				
				for (var i = 0; i < lgPos.get('positions').length; i++) {
					minNotMetPos[lgPos.get('positions')[i]] = true;
				}
			}
			
			//See if count is below max, then add lgPos positions
			if(count < lgPos.get('max')){
				for (var i = 0; i < lgPos.get('positions').length; i++) {
					nonMaxedOutPos[lgPos.get('positions')[i]] = true;
				}
			} else {
				for (var i = 0; i < lgPos.get('positions').length; i++) {
					maxedOutPos[lgPos.get('positions')[i]] = true;
				}
			}
		});
		
		var nonMaxedOutPosArr = [];
		for(var pos in nonMaxedOutPos) {
			if(nonMaxedOutPos[pos]){
				nonMaxedOutPosArr.push(pos);
			}			
		}
		
		var maxedOutPosArr = [];
		for(var pos in maxedOutPos) {
			//Flex could add positions that still have room, so make sure they aren't in nonMaxedOutPos array
			if(maxedOutPos[pos] && !nonMaxedOutPos[pos]){
				maxedOutPosArr.push(pos);
			}			
		}
		
		var minNotMetPosArr = [];
		for(var pos in minNotMetPos) {
			if(minNotMetPos[pos]){
				minNotMetPosArr.push(pos);
			}			
		}
		
		var teamPickCount = draftStatusModel.get('teamPickCount')[fantTeamId];
		var maxTeamPickCount = draftStatusModel.get('teamMaxNumPicks')[fantTeamId];
		if(minRemaining >= (maxTeamPickCount - teamPickCount)){
			//Can only draft positions with a min left that aren't maxed out
			draftStatusModel.get('allowedPositions')[fantTeamId] = minNotMetPosArr;
			draftStatusModel.get('teamMinPosRequired')[fantTeamId] = true;
		} else {
			//Can draft any position that isn't maxed out
			draftStatusModel.get('allowedPositions')[fantTeamId] = nonMaxedOutPosArr;
			draftStatusModel.get('teamMinPosRequired')[fantTeamId] = false;
		}
		
		draftStatusModel.get('teamMaxedPositions')[fantTeamId] = maxedOutPosArr;
	};
	
	var calcAllAllowedPositions = function() {
		var teamList = lgInstanceModel.getTeamList();
		
		_.each(teamList, function(team){
			var fantTeamId = team.get('id');
			calcAllowedPositions(fantTeamId);
		}, this);
	};
	
	var calcTeamMaxNumPicks = function() {
		var teamList = lgInstanceModel.getTeamList();
		var numPickMap = {};
		
		if(lgInstanceModel.get('draftType') != 'CUSTOM'){
			var rounds = lgInstanceModel.get('numRounds'); 
			
			_.each(teamList, function(team){ 
				numPickMap[team.get('id')] = rounds; 
			}, this);
		} else {
			pickCollection.each(function(pick) {
				var fantId = pick.get('fantasyTeamId'); 
				if(numPickMap[fantId] == null){
					numPickMap[fantId] = 1;
				} else {
					numPickMap[fantId] = numPickMap[fantId] + 1;
				}
			});
		}
		
		draftStatusModel.set({teamMaxNumPicks: numPickMap},{silent: true});
	};
	
	var loadPicks = function() {
		var teamPosMap = {};
		var teamPickCount = {};
		var teamBudget = {};
		
		//Initialize lists
		var teamList = lgInstanceModel.getTeamList();		
		_.each(teamList, function(team){
			var fantTeamId = team.get('id');
			teamPosMap[fantTeamId] = {};
			teamPickCount[fantTeamId] = 0;
			teamBudget[fantTeamId] = team.get('auctionBudget');
		}, this);
		
		var auctionPick = null;
		var isAuction = lgInstanceModel.get('draftType') == 'AUCTION';
		
		if(isAuction && rosterPositionCollection){
			//we need roster collections to wait until this method is done before it can continue processing
			rosterPositionCollection.setProcessChanges(false);
		}
		
		//Process through all of the picks that have already been made
		pickCollection.each(function(pick) {
			var playerObj = pick.get('draftablePlayer');
			
			if(playerObj){
				if(isAuction && !pick.get('keeper') && pick.get('value') == 0){
					auctionPick = pick;
					
					draftStatusModel.set({
						auctionBidding: true,
						auctionPickId: pick.get('id'),
						auctionBidPlayerId: pick.get('draftablePlayerId'),});
				} else {
					if(lgInstanceModel.get('id') == 69728){
	    				if(playerObj.id == 5123){
	    					//Nellie Cruz
	    					playerObj.positions = ["RF"];
	    					playerObj.position = "RF";
	    				} else if(playerObj.id == 9078){
	    					//Jose Peraza
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 4944){
	    					//Villar
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 4530){
	    					 //Carlos Santana 1b
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 4994){
	    					 //Pujols 1b
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 4444){
	    					 //Desmond CF
	    					playerObj.positions = ["CF"];
	    					playerObj.position = "CF";
	    				}	    				
	    			} else if(lgInstanceModel.get('id') == 194581){
	    				if(playerObj.id == 9448){
	    					//Max Muncy
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 19431){
	    					//David Fletcher
	    					playerObj.positions = ["SS"];
	    					playerObj.position = "SS";
	    				//} else if(playerObj.id == 15732){
	    					//Ohtani
	    				//	playerObj.positions = ["SP"];
	    				//	playerObj.position = "SP";
	    				} else if(playerObj.id == 21104){
	    					//Tommy Edman
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				}
					} else if(lgInstanceModel.get('id') == 237311){
						player = playerObj 
	
						//antlercody 
						if(player.draftablePlayerId == 29451){
	    					//Ohtani
	    					player.positions = ["DH"]; player.position = "DH";
	    				} else if(player.draftablePlayerId == 5044){
	    					//Manny Machado
	    					player.positions = ["DH"]; player.position = "DH";
	    				} else if(player.draftablePlayerId == 50723){
	    					//Isaac Paredes
	    					player.positions = ["2B"]; player.position = "2B";
	    				} 
	    			} else if(lgInstanceModel.get('id') == 237322){
						player = playerObj 
	
						//brian cutlip
						if(player.draftablePlayerId == 34099){
	    					//Yordan Alvarez
	    					player.positions = ["LF"]; player.position = "LF";
	    				}
					} else if(lgInstanceModel.get('id') == 217451){
	    				if(playerObj.id == 17504){
	    					//Yordan Alvarez
	    					playerObj.positions = ["LF"];
	    					playerObj.position = "LF";
	    				}
					} else if(lgInstanceModel.get('id') == 217712){
						if(playerObj.id == 15732){
	    					//Ohtani - keep as SP and also as OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 17504){
	    					//Yordan Alvarez - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 5123){
	    					//Nelson Cruz - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 18325){
	    					//Ty France - 1B
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 4942){
	    					//Marwin Gonzalez - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 13033){
	    					//Lourdes Guirriel - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 20778){
	    					//Joe Conner - 1B
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 18010){
	    					//Scott Kingery - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 5821){
	    					//Tommy LaStella 2B
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 12749){
	    					//Trey Mancini - 1B
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 6002){
	    					//JD Martinez - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 17540){
	    					//Jeff McNeil - 2B
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 4624){
	    					//Mike Moustakas - 3B
	    					playerObj.positions = ["3B"];
	    					playerObj.position = "3B";
	    				} else if(playerObj.id == 9448){
	    					//Max Muncy - 2B
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 17118){
	    					//Sheldon Neuse - 2B
	    					playerObj.positions = ["2B"];
	    					playerObj.position = "2B";
	    				} else if(playerObj.id == 4672){
	    					//Danny Santana - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 20651){
	    					//Gavin Sheets - 1B
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 5899){
	    					//Dominic Smith - 1B
	    					playerObj.positions = ["1B"];
	    					playerObj.position = "1B";
	    				} else if(playerObj.id == 4326){
	    					//Giancarlo Stanton - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 13018){
	    					//Luis Torrens - C
	    					playerObj.positions = ["C"];
	    					playerObj.position = "C";
	    				} else if(playerObj.id == 20875){
	    					//Daulton Varsho - OF
	    					playerObj.positions = ["OF"];
	    					playerObj.position = "OF";
	    				} else if(playerObj.id == 4944){
	    					//Jonathan Villar - 3B
	    					playerObj.positions = ["3B"];
	    					playerObj.position = "3B";
	    				}
	    			} else if(lgInstanceModel.get('id') == 201280){
						player = playerObj 
	
						if(player.draftablePlayerId == 34705){
	    					//4,Ronald Acuna Jr.,94,Braves,CF
	    					player.positions = ["CF"]; player.position = "CF";
	    				} else if(player.draftablePlayerId == 44214){
	    					//35,Freddy Peralta,86,Brewers,SP
	    					player.positions = ["SP"]; player.position = "SP";
	    				} else if(player.draftablePlayerId == 24172){
	    					//37,Teoscar Hernandez,86,Blue Jays,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 29451){
	    					//38,Shohei Ohtani,86,Angels,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 15135){
	    					//40,Ketel Marte,86,Diamondbacks,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 49958){
	    					//45,Bryan Reynolds,85,Pirates,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 5501){
	    					//54,Marcus Semien,85,Blue Jays,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 5505){
	    					//57,Avisail Garcia,84,Brewers,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 34710){
	    					//59,Kyle Tucker,84,Astros,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 5818){
	    					//80,Jean Segura,83,Phillies,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 11530){
	    					//93,Joey Gallo,82,Yankees,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 22179){
	    					//101,Adam Engel,82,White Sox,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 28976){
	    					//102,Alex Verdugo,82,Red Sox,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 5332){
	    					//104,Giancarlo Stanton,82,Yankees,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 15090){
	    					//107,Adam Duvall,81,Braves,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 44153){
	    					//111,David Fletcher,81,Angels,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 50101){
	    					//113,Tommy Edman,81,Cardinals,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 22212){
	    					//122,Jesse Winker,81,Reds,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 21170){
	    					//143,Chris Taylor,80,Dodgers,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 34099){
	    					//150,Yordan Alvarez,80,Astros,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 49447){
	    					//153,Michael Kopech,80,White Sox,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44191){
	    					//155,Isiah Kiner-Falefa,80,Rangers,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 15496){
	    					//172,Aledmys Diaz,79,Astros,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 29353){
	    					//177,Ranger Suarez,79,Phillies,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 26347){
	    					//181,Austin Hays,79,Orioles,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 49353){
	    					//182,Ryan Mountcastle,79,Orioles,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 51431){
	    					//184,Nico Hoerner,79,Cubs,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 7500){
	    					//185,J.D. Martinez,79,Red Sox,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 19026){
	    					//187,Whit Merrifield,79,Royals,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 15600){
	    					//206,Raimel Tapia,78,Rockies,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 28369){
	    					//207,Ryan McMahon,78,Rockies,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 15558){
	    					//211,Tyler Naquin,78,Reds,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 6129){
	    					//216,Nelson Cruz,78,Rays,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 5905){
	    					//221,Randal Grichuk,78,Blue Jays,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 8672){
	    					//236,Enrique Hernandez,78,Red Sox,2B First Name originally Kike  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 29333){
	    					//240,Yonny Chirinos,77,Rays,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 44295){
	    					//244,Jeff McNeil,77,Mets,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 5865){
	    					//248,Andrew McCutchen,77,Phillies,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 49487){
	    					//250,Connor Joe,77,Rockies,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 49631){
	    					//252,Josh Rojas,77,Diamondbacks,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 50072){
	    					//255,Kyle Lewis,77,Mariners,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 5682){
	    					//275,Max Kepler,77,Twins,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 65072){
	    					//282,Ha-seong Kim,76,Padres,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 6172){
	    					//283,Gerardo Parra,76,Nationals,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 52473){
	    					//291,Tyrone Taylor,76,Brewers,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 49962){
	    					//292,David Bednar,76,Pirates,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 28912){
	    					//293,J.D. Davis,76,Mets,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 22216){
	    					//319,Brett Phillips,76,Rays,CF  <-- Chang
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 15586){
	    					//328,Harold Ramirez,76,Indians,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 33605){
	    					//335,Nicky Lopez,76,Royals,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 44483){
	    					//338,Ramon Urias,76,Orioles,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 50107){
	    					//345,Dylan Carlson,75,Cardinals,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 66681){
	    					//349,Jonathan India,75,Reds,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 49482){
	    					//356,Kyle Farmer,75,Reds,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 44067){
	    					//359,Willians Astudillo,75,Twins,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 62187){
	    					//360,Luis Patino,75,Rays,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 52507){
	    					//361,Jordan Romano,75,Blue Jays,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 51829){
	    					//362,Chas McCormick,75,Astros,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 52390){
	    					//383,Jazz Chisholm,74,Marlins,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 28842){
	    					//384,Brian Goodwin,74,White Sox,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 33730){
	    					//385,LaMonte Wade Jr.,74,Giants,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 44232){
	    					//386,Kevin Newman,74,Pirates,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 50064){
	    					//393,Dylan Moore,74,Mariners,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 49479){
	    					//400,Lucas Sims,74,Reds,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44071){
	    					//404,Jake Cave,74,Twins,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 61184){
	    					//414,Seth Brown,74,Athletics,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 28596){
	    					//420,Miguel Andujar,74,Yankees,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 49452){
	    					//421,Zach Thompson,73,Marlins,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49325){
	    					//426,Rafael Ortega,73,Cubs,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 33788){
	    					//427,Jon Berti,73,Marlins,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 29394){
	    					//428,Mauricio Dubon,73,Giants,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 19081){
	    					//433,Matt Carpenter,73,Cardinals,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 60875){
	    					//435,Sam Coonrod,73,Phillies,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 22210){
	    					//441,Aristides Aquino,73,Reds,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 5636){
	    					//443,Jarrod Dyson,73,Royals,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 49682){
	    					//447,John Curtiss,73,Brewers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 33678){
	    					//454,Josh Naylor,73,Indians,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 44522){
	    					//459,Kolby Allard,73,Rangers,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 44848){
	    					//462,Jonathan Loaisiga,73,Yankees,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 65326){
	    					//466,Tyler Wells,73,Orioles,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 15150){
	    					//470,Travis Jankowski,72,Phillies,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 21050){
	    					//474,Ehire Adrianza,72,Braves,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 61990){
	    					//475,Shogo Akiyama,72,Reds,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 28892){
	    					//478,Jimmy Nelson,72,Dodgers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 5678){
	    					//479,Danny Santana,72,Red Sox,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 15349){
	    					//480,Jurickson Profar,72,Padres,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 5321){
	    					//483,Donovan Solano,72,Giants,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 22243){
	    					//504,Lewis Brinson,72,Marlins,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 49827){
	    					//506,Luis Guillorme,72,Mets,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 44151){
	    					//507,Taylor Ward,72,Angels,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 26228){
	    					//513,Paolo Espino,72,Nationals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 44136){
	    					//522,Josh James,72,Astros,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 28851){
	    					//529,Leury Garcia,72,White Sox,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 61994){
	    					//530,Andrew Vaughn,72,White Sox,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 49356){
	    					//544,Rio Ruiz,72,Rockies,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 49386){
	    					//547,Michael Chavis,72,Pirates,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 25986){
	    					//557,Dominic Smith,71,Mets,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 6073){
	    					//561,Brad Miller,71,Phillies,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 6164){
	    					//567,Chris Owings,71,Rockies,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 28456){
	    					//576,Yandy Diaz,71,Rays,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 49460){
	    					//585,Danny Mendick,71,White Sox,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 20017){
	    					//589,Chad Pinder,71,Athletics,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 44035){
	    					//592,Niko Goodrum,71,Tigers,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 49648){
	    					//597,Jake Kalish,71,Royals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 28995){
	    					//601,Christian Arroyo,71,Red Sox,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 26277){
	    					//603,Greg Allen,71,Yankees,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 11538){
	    					//610,Wilmer Difo,70,Pirates,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 29377){
	    					//611,Wily Peralta,70,Tigers,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 44134){
	    					//613,Billy McKinney,70,Dodgers,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 28913){
	    					//615,Colin Moran,70,Pirates,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 44977){
	    					//621,Erik Swanson,70,Mariners,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44199){
	    					//626,David Bote,70,Cubs,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 50179){
	    					//629,Eli White,70,Rangers,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 67566){
	    					//652,Lars Nootbaar,69,Cardinals,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 50110){
	    					//657,Lane Thomas,69,Nationals,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 28777){
	    					//659,Caleb Smith,69,Diamondbacks,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 5541){
	    					//662,Asdrubal Cabrera,69,Diamondbacks,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 49883){
	    					//663,Jorge Mateo,69,Orioles,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 45126){
	    					//667,Ryan Thompson,69,Rays,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 62048){
	    					//671,Nate Pearson,69,Blue Jays,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 28597){
	    					//682,Tyler Wade,69,Yankees,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 49299){
	    					//686,Rob Refsnyder,68,Twins,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 67468){
	    					//690,Johneshwy Fargas,68,Cubs,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 18495){
	    					//691,Luis Perdomo,68,Brewers,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 51284){
	    					//700,Hoy Jun Park,68,Pirates,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 51627){
	    					//706,Alex Young,68,Indians,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 20024){
	    					//715,Brent Suter,68,Brewers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 64783){
	    					//718,Phil Bickford,68,Dodgers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49422){
	    					//728,Justin Steele,68,Cubs,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 6120){
	    					//741,Mitch Moreland,68,Athletics,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 15509){
	    					//743,Michael Fulmer,68,Tigers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 29371){
	    					//745,Gregory Soto,68,Tigers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 64755){
	    					//746,Ljay Newsome,68,Mariners,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 22187){
	    					//750,Jakob Junis,68,Royals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 15353){
	    					//755,Tyler Chatwood,68,Giants,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 67597){
	    					//764,Jarren Duran,67,Red Sox,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 65024){
	    					//784,Jordan Sheffield,67,Rockies,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 61912){
	    					//787,Blake Taylor,67,Astros,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44144){
	    					//789,Taylor Cole,67,Angels,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49448){
	    					//791,Jimmy Lambert,67,White Sox,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 44045){
	    					//793,Jorge Lopez,67,Orioles,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 61927){
	    					//803,Carlos Hernandez,67,Royals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 64946){
	    					//818,Alec Bettinger,66,Brewers,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 6133){
	    					//828,Chase Anderson,66,Phillies,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49901){
	    					//830,Adonis Medina,66,Phillies,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 50206){
	    					//831,Austin Voth,66,Nationals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44876){
	    					//840,Justus Sheffield,66,Mariners,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 51460){
	    					//861,Trevor Megill,65,Cubs,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49752){
	    					//863,Angel Perdomo,65,Brewers,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 64943){
	    					//874,Keegan Thompson,65,Cubs,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49478){
	    					//878,Tony Santillan,65,Reds,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 34736){
	    					//892,Carter Kieboom,65,Nationals,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 49495){
	    					//895,Taylor Trammell,65,Mariners,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 44984){
	    					//896,Taylor Hearn,65,Rangers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 61985){
	    					//903,Yoshitomo Tsutsugo,65,Pirates,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 52215){
	    					//905,Enoli Paredes,65,Astros,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49336){
	    					//914,Dean Kremer,65,Orioles,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 50723){
	    					//917,Isaac Paredes,65,Tigers,3B  <-- Change
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 49945){
	    					//926,Brandon Waddell,64,Cardinals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 64956){
	    					//938,Stuart Fairchild,64,Diamondbacks,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 51158){
	    					//947,Mauricio Llovera,64,Phillies,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 64744){
	    					//951,Seth Romero,64,Nationals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 29136){
	    					//952,Jefry Rodriguez,64,Nationals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 61955){
	    					//971,Ashton Goudeau,64,Rockies,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49555){
	    					//972,Tyler Nevin,64,Orioles,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 49704){
	    					//975,Michael Hermosillo,63,Cubs,RF  <-- Change
							player.positions = ["RF"]; player.position = "RF";
						} else if(player.draftablePlayerId == 49505){
	    					//979,J.C. Mejia,63,Indians,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49897){
	    					//984,Tyler Gilbert,63,Diamondbacks,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49634){
	    					//985,Ronnie Dawson,63,Astros,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 29326){
	    					//986,Domingo Acevedo,63,Athletics,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 64963){
	    					//987,Mason Thompson,63,Nationals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 5616){
	    					//989,Ervin Santana,63,Royals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44492){
	    					//993,Taylor Clarke,63,Diamondbacks,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 29335){
	    					//994,Jose Mujica,63,Rockies,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49938){
	    					//996,Chad Kuhl,63,Pirates,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 21417){
	    					//997,Carson Fulmer,63,Reds,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44239){
	    					//1002,Daniel Ponce de Leon,63,Cardinals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 50219){
	    					//1008,Andrew Stevenson,63,Nationals,LF  <-- Change
							player.positions = ["LF"]; player.position = "LF";
						} else if(player.draftablePlayerId == 49609){
	    					//1013,Bryan Abreu,63,Astros,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 5480){
	    					//1014,Jose Quintana,63,Angels,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49700){
	    					//1016,Matt Thaiss,63,Angels,1B  <-- Change
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 20072){
	    					//1022,JaCoby Jones,63,Tigers,CF  <-- Change
							player.positions = ["CF"]; player.position = "CF";
						} else if(player.draftablePlayerId == 23133){
	    					//1026,Brent Honeywell Jr.,63,Rays,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 64794){
	    					//1028,Jonathan Stiever,63,White Sox,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 5971){
	    					//1033,Garrett Richards,63,Red Sox,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 61983){
	    					//1037,Michael Rucker,62,Cubs,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67594){
	    					//1038,Reiss Knehr,62,Padres,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 67596){
	    					//1043,Charlie Barnes,62,Twins,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 21481){
	    					//1044,Jhoulys Chacin,62,Rockies,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 50606){
	    					//1050,Riley Smith,62,Diamondbacks,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 9197){
	    					//1051,Daniel Norris,62,Brewers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 61939){
	    					//1054,Kyle Cody,62,Rangers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 52283){
	    					//1055,Eduard Bazardo,62,Red Sox,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 51073){
	    					//1058,Martin Perez,62,Red Sox,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67458){
	    					//1060,Nick Allgeyer,61,Blue Jays,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 67570){
	    					//1062,Konner Wade,61,Orioles,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 20205){
	    					//1070,Trevor Williams,61,Mets,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 29525){
	    					//1071,Julian Fernandez,61,Rockies,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 44968){
	    					//1073,Patrick Murphy,61,Nationals,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49485){
	    					//1080,Alex Blandino,60,Reds,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 28366){
	    					//1084,Jeff Hoffman,60,Reds,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 52453){
	    					//1088,Jacob Waguespack,60,Blue Jays,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 51164){
	    					//1089,Nick Maton,60,Phillies,SS  <-- Change
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 44966){
	    					//1097,Yennsy Diaz,59,Mets,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49999){
	    					//1099,Conner Menez,59,Giants,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 61934){
	    					//1100,Miguel Yajure,59,Pirates,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 12519){
	    					//1103,Chi Chi Gonzalez,59,Rockies,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67750){
	    					//1115,Justin Bruihl,58,Dodgers,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 52249){
	    					//1116,Otto Lopez,58,Blue Jays,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 51775){
	    					//1118,Daniel Camarena,58,Padres,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 67578){
	    					//1120,Aaron Ashby,58,Brewers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 65022){
	    					//1126,Luis Oviedo,58,Pirates,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 50630){
	    					//1128,Vimael Machin,58,Athletics,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 61956){
	    					//1137,Antonio Santos,57,Rockies,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67568){
	    					//1142,Justin Garza,57,Indians,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 50093){
	    					//1146,Jake Woodford,57,Cardinals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 51638){
	    					//1148,Rylan Bannon,57,Orioles,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 29427){
	    					//1152,Dennis Santana,57,Rangers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 50215){
	    					//1154,Adrian Sanchez,56,Nationals,2B  <-- Change
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 49834){
	    					//1158,Chance Adams,56,Royals,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67564){
	    					//1161,Jake Cousins,56,Brewers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49615){
	    					//1162,Ryan Hartman,56,Orioles,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 64743){
	    					//1164,Wes Benjamin,56,Rangers,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 50743){
	    					//1168,Jorge Guzman,55,Marlins,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67535){
	    					//1173,Mac Sceroler,55,Reds,SP  <-- Change
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 49804){
	    					//1175,Anthony Kay,55,Blue Jays,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 64927){
	    					//1181,Jay Groome,55,Red Sox,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 67735){
	    					//1188,Sean Guenther,54,Marlins,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						} else if(player.draftablePlayerId == 49769){
	    					//1195,Chase De Jong,50,Pirates,RP  <-- Change
							player.positions = ["RP"]; player.position = "RP";
						}
		
					} else if(lgInstanceModel.get('id') == 257149){
						player = playerObj;
	
						//brian cutlip
						if(player.draftablePlayerId == 5329){
	    					//Marcel Ozuna
	    					player.positions = ["LF"]; player.position = "LF";
	    				} else if (player.draftablePlayerId == 29362){
	    					//Eloy Jimenez
	    					player.positions = ["LF"]; player.position = "LF";
	    				} 
					} else if(lgInstanceModel.get('id') == 256905){
						player = playerObj;
						
						//Trey Garrison
						if(player.draftablePlayerId == 5082){
	    					//Xander Bogaerts
	    					player.positions = ["SS"]; player.position = "SS";
	    				} else if (player.draftablePlayerId == 75133){
		    				//Matt McLain
	    					player.positions = ["2B"]; player.position = "2B";
	    				} else if (player.draftablePlayerId == 76601){
		    				//Jackson Holliday
	    					player.positions = ["2B"]; player.position = "2B";
	    				}
    				} else if(lgInstanceModel.get('id') == 257448){
						player = playerObj;
						
						//Al Rodack
						if(player.draftablePlayerId == 7048){
							// Mookie Betts
							player.positions = ["SS"]; player.position = "SS";
						} else if (player.draftablePlayerId == 34142){
							// Cavan Biggio 
							player.positions = ["3B"]; player.position = "3B";
						} else if (player.draftablePlayerId == 62049){
							// Alec Bohm
							player.positions = ["3B"]; player.position = "3B";
						} else if (player.draftablePlayerId == 6834){
							// Kris Bryant
							player.positions = ["1B"]; player.position = "1B";		
						} else if (player.draftablePlayerId == 72051){
							// Elly De La Cruz
							player.positions = ["SS"]; player.position = "SS";
						} else if (player.draftablePlayerId == 51835){
							// Brendan Donovan
							player.positions = ["LF"]; player.position = "LF";	
						} else if (player.draftablePlayerId == 50101){
							// Tommy Edman
							player.positions = ["2B"]; player.position = "2B";	
						} else if (player.draftablePlayerId == 71538){
							// Gunnar Henderson
							player.positions = ["SS"]; player.position = "SS";
						} else if (player.draftablePlayerId == 49791){
							// Alex Kiriloff
							player.positions = ["1B"]; player.position = "1B";
						} else if (player.draftablePlayerId == 49699){
							// Tommy LaStella
							player.positions = ["2B"]; player.position = "2B";
						} else if (player.draftablePlayerId == 6205){
							// DJ LeMahieu
							player.positions = ["3B"]; player.position = "3B";
						} else if (player.draftablePlayerId == 7500){
							// JD Martinez
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 75133){
							// Matt McLain
							player.positions = ["2B"]; player.position = "2B";
						} else if (player.draftablePlayerId == 5865){
							// Andrew McCutchen
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 51784){
							// Elehuris Montero
							player.positions = ["1B"]; player.position = "1B";
						} else if (player.draftablePlayerId == 29451){
							// Shohei Ohtani
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 5329){
							// Marcell Ozuna
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 49792){
							// Luke Raley
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 5332){
							// Giancarlo Stanton
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 71543){
							// Spencer Steer
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 21170){
							// Chris Taylor
							player.positions = ["LF"]; player.position = "LF";
						} else if (player.draftablePlayerId == 7034){
							// Justin Turner
							player.positions = ["1B"]; player.position = "1B";
						} else if (player.draftablePlayerId == 75618){
							// Jordan Westburg
							player.positions = ["3B"]; player.position = "3B";
						}
    				} else if(lgInstanceModel.get('id') == 276217){
						player = playerObj;
						
						if(player.draftablePlayerId == 22803){
		    				//Cody Bellinger
		    				player.positions = ["RF"]; player.position = "RF";
		    			} else if(player.draftablePlayerId == 52480){
		    				//McCarthy, Jake
		    				player.positions = ["RF"]; player.position = "RF";
		    			} else if(player.draftablePlayerId == 76602){
		    				//Manzardo, Kyle
		    				player.positions = ["DH"]; player.position = "DH";
		    			} else if(player.draftablePlayerId == 72146){
		    				//Yoshida, Masataka
		    				player.positions = ["DH"]; player.position = "DH";
		    			} else if(player.draftablePlayerId == 51630){
		    				//Smith, Pavin
		    				player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 76011){
		    				//Goodman, Hunter
		    				player.positions = ["RF"]; player.position = "RF";
		    			}
    				} else if(lgInstanceModel.get('id') == 276190){
						player = playerObj;
						
						if(player.draftablePlayerId == 5945){
		    				//Jose Altuve - CF 5945
		    				player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 5082){
		    				//Xander Bogaerts – SS 5082
							player.positions = ["SS"]; player.position = "SS";
		    			} else if(player.draftablePlayerId == 6834){
							//Kris Bryant – 1B 6834
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 71547){
							//Alec Burleson – 1B 71547
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 81900){
							//Kristian Campbell – 2B 81900
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 29365){
							//Willi Castro – 2B 29365
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 52390){
							//Jazz Chisholm – 2B 52390
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 15574){
							//Willson Contreras – 1B 15574
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 50779){
							//O’Neil Cruz - CF 50779
							player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 51835){
							//Brendan Donovan – 2B 51835
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 50101){
							//Tommy Edman – 2B 50101
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 76059){
							//Tyler Fitzgerald – 2B 76059
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 68536){
							//Bowden Francis - SP 68536
							player.positions = ["SP"]; player.position = "SP";
		    			} else if(player.draftablePlayerId == 76011){
							//Hunter Goodman – 1B 76011
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 8672){
							//Enrique Hernandez - SS 8672
							player.positions = ["SS"]; player.position = "SS";
		    			} else if(player.draftablePlayerId == 49937){
							//Clay Holmes - SP 49937
							player.positions = ["SP"]; player.position = "SP";
		    			} else if(player.draftablePlayerId == 52460){
							//Grant Holmes - SP 52460
							player.positions = ["SP"]; player.position = "SP";
		    			} else if(player.draftablePlayerId == 44191){
							//Isiah Kiner-Falefa – SS 44191
							player.positions = ["SS"]; player.position = "SS";
		    			} else if(player.draftablePlayerId == 7376){
							//Nick Martinez - SP 7376
							player.positions = ["SP"]; player.position = "SP";
		    			} else if(player.draftablePlayerId == 68514){
							//Jose Miranda – 1B 68514
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 50064){
							//Dylan Moore – 2B 50064
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 29451){
							//Shohei Ohtani – CF 29451 
							player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 64944){
							//Christopher Morel – CF 64944
							player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 18466){
							//Jorge Polanco – 3B 18466
							player.positions = ["3B"]; player.position = "3B";
		    			} else if(player.draftablePlayerId == 51341){
							//Luis Rengifo – 2B 51341
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 49794){
							//Brent Rooker - CF 49794
							player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 12544){
							//Kyle Schwarber – CF 12544
							player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 81898){
							//Matt Shaw – 3B 81898
							player.positions = ["3B"]; player.position = "3B";
		    			} else if(player.draftablePlayerId == 5332){
							//Giancarlo Stanton - CF 5332
							player.positions = ["CF"]; player.position = "CF";
		    			} else if(player.draftablePlayerId == 71543){
							//Spencer Steer – 1B 71543
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 50136){
							//Jake Croneworth – 2B 50136
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 75133){
							//Matt McClain – 2B 75133
							player.positions = ["2B"]; player.position = "2B";
		    			}
					}  else if(lgInstanceModel.get('id') == 276481){
						player = playerObj;
						
						if(player.draftablePlayerId == 71543){
							//Spencer Steer @1B 71543
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 75133){
							//Matt McLain @2B 75133
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 52390){
							//Jazz Chisholm @3B 52390
							player.positions = ["3B"]; player.position = "3B";
		    			} else if(player.draftablePlayerId == 44588){
							//Jake Burger @3B 44588
							player.positions = ["3B"]; player.position = "3B";
		    			} else if(player.draftablePlayerId == 75618){
							//Jordan Westburg @2B 75618
							player.positions = ["2B"]; player.position = "2B";
		    			} else if(player.draftablePlayerId == 28456){
							//Yandy Diaz @1B 28456
							player.positions = ["1B"]; player.position = "1B";
		    			} else if(player.draftablePlayerId == 68964){
							//Ceddane Rafaela @SS 68964
							player.positions = ["SS"]; player.position = "SS";
		    			}
					}  else if (lgInstanceModel.get('id') == 293075) {
						player = playerObj;
						
						if(player.draftablePlayerId == 5945){
							//Jose Altuve  -  2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 44473){
							//Luis Arraez  - 2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 72035){
							//Addison Barger - OF
							player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 34707){
							//Bo Bichette  - 3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 34142){
							//Cavan Biggio  -  2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 68585){
							//Jonah Bride  -  1B
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 6834){
							//Kris Bryant  -  1B
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 72013){
							//Joey Cantillo  -  SP
							player.positions = ["SP"]; player.position = "SP";
						} else if(player.draftablePlayerId == 29365){
							//Willi Castro  -  3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 52390){
							//Jazz Chisholm  -  2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 49522){
							//Ernie Clement  -  2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 11564){
							//Carlos Correa  -  3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 50779){
							//O'Neil Cruz  -  OF
							player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 51835){
							//Brendan Donovan  -  3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 29394){
							//Mauricio Dubon  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 72064){
							//Xavier Edwards  -  2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 76059){
							//Tyler Fitzgerald  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 50211){
							//Luis Garcia  -  1B
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 25728){
							//Rafeal Devers  -  1B
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 75613){
							//Nick Gonzales  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 62184){
							//Nolan Gorman  -  3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 8672){
							//Enrique Hernandez  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 79913){
							//Brooks Lee  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 52249){
							//Otto Lopez  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 79958){
							//Coby Mayo  -  3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 51209){
							//Zach McKinstry  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 68514){
							//Jose Miranda  -  1B
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 50064){
							//Dylan Moore  -  SS
							player.positions = ["SS"]; player.position = "SS";
						} else if(player.draftablePlayerId == 44054){
							//Ryan O'Hearn  -  OF
							player.positions = ["OF"]; player.position = "OF";
						//} else if(player.draftablePlayerId == XXXXX){
							//Shohei Ohtani   -  SP
							//player.positions = ["SP"]; player.position = "SP";
						//} else if(player.draftablePlayerId == XXXXX){
							//Shohei Ohtani  -  OF
							//player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 5329){
							//Marcell Ozuna  -  OF
							player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 18466){
							//Jorge Polanco  -  1B
							player.positions = ["1B"]; player.position = "1B";
						} else if(player.draftablePlayerId == 49794){
							//Brent Rooker  -  OF
							player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 12544){
							//Kyle Schwarber  -  OF
							player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 71134){
							//Josh Smith  -  2B
							player.positions = ["2B"]; player.position = "2B";
						} else if(player.draftablePlayerId == 5332){
							//Giancarlo Stanton  -  OF
							player.positions = ["OF"]; player.position = "OF";
						} else if(player.draftablePlayerId == 33680){
							//Luis Urias  -  3B
							player.positions = ["3B"]; player.position = "3B";
						} else if(player.draftablePlayerId == 44483){
							//Ramon Urias  -  2B
							player.positions = ["2B"]; player.position = "2B";
						}
						
					}
					
					//increment team pick count
					teamPickCount[pick.get('fantasyTeamId')] = teamPickCount[pick.get('fantasyTeamId')] + 1;
					
					//subtract from budget
					if(lgInstanceModel.get('draftType') == 'AUCTION'){
						teamBudget[pick.get('fantasyTeamId')] =  teamBudget[pick.get('fantasyTeamId')] - pick.get('value');
					}
					
					var roundPosId = pickSummaryCollection.getPosRoundId(pick.get('round'), pick.get('posInRound'));					
					//if(isAuction){
					//	var team = lgInstanceModel.getTeam(pick.get('fantasyTeamId'));
					//	roundPosId = pickSummaryCollection.getPosRoundId(teamPickCount[pick.get('fantasyTeamId')], team.get('draftPosition'));
					//}
					
					if(teamPosMap[pick.get('fantasyTeamId')]['ALL_POSITIONS'] == null){
						teamPosMap[pick.get('fantasyTeamId')]['ALL_POSITIONS'] = [];
					}				
					teamPosMap[pick.get('fantasyTeamId')]['ALL_POSITIONS'].push(roundPosId);
					
					for (var i = 0; i<playerObj.positions.length; i++) {
						var curPos = playerObj.positions[i];
						var lgPosIdArr = lgInstanceModel.get('leaguePositions').getLgPositionsForType(curPos);
						
						if(lgPosIdArr != null){
							for (var j = 0; j < lgPosIdArr.length; j++) {
								var lgPosId = lgPosIdArr[j];
								
								if(teamPosMap[pick.get('fantasyTeamId')][lgPosId] == null){
									teamPosMap[pick.get('fantasyTeamId')][lgPosId] = [];
								}
								
								teamPosMap[pick.get('fantasyTeamId')][lgPosId].push(roundPosId);
							}
						}
					}
				}
			} 
		});
		
		//Remove picks that are only bids and not finalized
		if(auctionPick) {
			var position = '';
			for (var i = 0; i<auctionPick.get('draftablePlayer')['positions'].length; i++) {
				if(i > 0){
					position += ',';
				}
				position += auctionPick.get('draftablePlayer')['positions'][i];
			}
			
			draftStatusModel.set({
				auctionBidding: true,
				auctionPickId : auctionPick.get('id'),
				auctionBidPlayerId: auctionPick.get('draftablePlayerId'),
				auctionManualPlayerPos : position,
				auctionManualPlayerByeWeek : auctionPick.get('draftablePlayer')['byeWeek'],
				auctionManualPlayerTeamAbbr : auctionPick.get('draftablePlayer')['teamAbbr'],
				auctionManualPlayerFirstName : auctionPick.get('draftablePlayer')['firstName'],
				auctionManualPlayerLastName : auctionPick.get('draftablePlayer')['lastName']});
			
			pickCollection.remove(auctionPick);
		}
		
		draftStatusModel.set({
			teamPosMap: teamPosMap,
			teamPickCount: teamPickCount,
			teamBudget: teamBudget},{silent: true});
		calcAllAllowedPositions();
		
		//Process through all of the picks that have already been made
		if(isAuction){
			_.each(teamList, function(team){
				var fantTeamId = team.get('id');
				var draftPos = team.get('draftPosition');
				var teamPicks = pickCollection.getPicksByTeam(fantTeamId);
				
				var curPos = 1;
				_.each(teamPicks, function(pick){
					var pickSummary = pickSummaryCollection.get(pickSummaryCollection.getPosRoundId(curPos, draftPos));
					var playerObj = pick.get('draftablePlayer');
					if(playerObj){
						var position = '';
						for (var i = 0; i<playerObj.positions.length; i++) {
							if(i > 0){
								position += ',';
							}
							position += playerObj.positions[i];
						}
						
						pickSummary.set({pickId: pick.get('id'),
							keeper: pick.get('keeper'),
							autoDrafted: pick.get('autoDrafted'),
							playerPos: position,
							byeWeek: playerObj.byeWeek,
							teamAbbr: playerObj.teamAbbr,
							fName: playerObj.firstName,
							lName: playerObj.lastName,
							fantasyTeamId : pick.get('fantasyTeamId'),
							draftablePlayerId : pick.get('draftablePlayerId'),
							auctionValue: pick.get('value'),
							auctionRound: pick.get('round'),
							auctionPosInRound: pick.get('posInRound')},{});
						
						curPos++;
					}
					
				}, this);
				
				//Clear the extras here instead of sync method
				for(var i= curPos; i <= lgInstanceModel.get('numRounds'); i++){
					var pickSummary = pickSummaryCollection.get(pickSummaryCollection.getPosRoundId(i, draftPos));
					pickSummary.clearKeepTeam();
				}				
			}, this);			
		} else {
			pickCollection.each(function(pick) {
				var pickSummary = null;
				var bidValue = 0;
				var auctionRound = null;
				
				pickSummary = pickSummaryCollection.get(pickSummaryCollection.getPosRoundId(pick.get('round'), pick.get('posInRound')));
				
				var playerObj = pick.get('draftablePlayer');
				
				if(playerObj){
					//Place commas in the string if the player is in multiple positions
					var position = '';
					for (var i = 0; i<playerObj.positions.length; i++) {
						if(i > 0){
							position += ',';
						}
						position += playerObj.positions[i];
					}
					
					pickSummary.set({pickId: pick.get('id'),
						keeper: pick.get('keeper'),
						autoDrafted: pick.get('autoDrafted'),
						playerPos: position,
						byeWeek: playerObj.byeWeek,
						teamAbbr: playerObj.teamAbbr,
						fName: playerObj.firstName,
						lName: playerObj.lastName,
						fantasyTeamId : pick.get('fantasyTeamId'),
						draftablePlayerId : pick.get('draftablePlayerId'),
						auctionValue: bidValue,
						auctionRound: auctionRound},{});
				}
			});
		}
		
		if(isAuction && rosterPositionCollection){
			//we need roster collections to wait until this method is done before it can continue processing
			rosterPositionCollection.setProcessChanges(true);
			rosterPositionCollection.populateAllRosters();
		}
	};

	var updateDraftStatus = function() {
		var curRoundPickId = pickSummaryCollection.getCurrentPosRoundId();
		var round = null;
		var posInRound = null;
		var draftingTeamId = null;
		var completed = false;
		if(lgInstanceModel.get('draftType') == 'AUCTION') {
			round = Math.floor(curRoundPickId / 1000.0);
			posInRound = curRoundPickId % 1000;
			draftingTeamId = lgInstanceModel.getTeamByDraftPosition(posInRound).get('id');
		} else if(curRoundPickId > -1){
			var pickSum = pickSummaryCollection.get(curRoundPickId);
			round = pickSum.get('round');
			posInRound = pickSum.get('posInRound');
			draftingTeamId = pickSum.get('fantasyTeamId'); 
		} else {
			//round = lgInstanceModel.get('numRounds') + 1;
			round = 1;
			posInRound = 1;
			draftingTeamId = lgInstanceModel.getTeamByDraftPosition(1).get('id');
		}
		
		if(lgInstanceModel.get('draftType') != 'AUCTION' && curRoundPickId == -1){
			completed = true;
		} else if(lgInstanceModel.get('draftType') == 'AUCTION'){
			completed = pickSummaryCollection.isAuctionComplete();
		}
		
		draftStatusModel.set({
			draftingTeamId: draftingTeamId,
			round: round,
			posInRound: posInRound,
			completed: completed});
		
		if(completed){
			lgInstanceModel.set({draftStatus: 'COMPLETED'});
		}
	};
	
	var updateDraftedPlayers = function() {
		//Process through all of the picks that have already been made
		if(playerList.findPlayerByDraftPlayerId){
			pickCollection.each(function(pick) {
				//Playerlist might not be loaded yet
				if(pick.get('draftablePlayerId') 
						&& pick.get('draftablePlayerId') > 0 
						&& (lgInstanceModel.get('draftType') != 'AUCTION' || pick.get('value') > 0)){  //We only want auction picks with values
					var foundPlayer = playerList.findPlayerByDraftPlayerId(pick.get('draftablePlayerId'));
					if(foundPlayer && !foundPlayer.drafted){
						foundPlayer.drafted = true; 
						$(document).trigger('draftApp:playerPicked', foundPlayer.id);
					}
				}
			});
		}
	};
	
	var syncPicks = function() {
		//Update all the pick summaries to ensure that every pick is in a pick summary
		loadPicks();
		updateDraftedPlayers();
		
		//Check all the pick summaries to see if there are extras, and then remove them
		if(lgInstanceModel.get('draftType') != 'AUCTION'){
			pickSummaryCollection.each(function(pickSummary) {
				var foundPick = pickCollection.get(pickSummary.get('pickId'));
				
				if(pickSummary.get('draftablePlayerId') && (!foundPick || foundPick.get('draftablePlayerId') == 0)){
					var foundPlayer = playerList.findPlayerByDraftPlayerId(pickSummary.get('draftablePlayerId'));
					if(foundPlayer && foundPlayer.drafted){
						foundPlayer.drafted = false;
						$(document).trigger('draftApp:playerUnpicked', foundPlayer.id);
					}
					
					pickSummary.clearKeepTeam();
				}
				
			});
		}		
		
		updateDraftStatus();
	};

	var updateTimer = function(timerData, sendDraftStatusUpdate) {
		var silent = sendDraftStatusUpdate ? false : true;
		
		var curTimeDiff = (new Date()).getTime() - timerData.serverTime;
		var isAuction = lgInstanceModel.get('draftType') == 'AUCTION' ? true : false;
		
		//If the timer difference has been within a second precision for 3 consecutive times, it should be good so lets leave it
		//This prevents a single high latency call from messing up a timer (::cough cough:: mobile chrome)
		if(serverTimeDiffCount < 3 && (curTimeDiff - serverTimeDiff) < 500 && (curTimeDiff - serverTimeDiff) > -500) {
			serverTimeDiffCount++;
		} else if (serverTimeDiffCount < 4){
			serverTimeDiff = curTimeDiff;
			serverTimeDiffCount = 0;
		}
		
		//serverTimeDiff = (new Date()).getTime() - timerData.serverTime;
		var auctionBidValue = 0;
		var auctionWinningTeamId = null;
		
		if(isAuction) {
			auctionBidValue = timerData.auctionValue;
			auctionWinningTeamId = timerData.auctionTeamId;
		}
		
		timerModel.set({
			isActive: timerData.active,
			endTime: timerData.endTime,
			duration: timerData.duration,
			pauseTimeRemaining: timerData.pauseTimeRemaining,
			serverTimeDiff: serverTimeDiff,
		});
		
		draftStatusModel.set({
			auctionBidValue: auctionBidValue,
			auctionWinningTeamId: auctionWinningTeamId},{silent: silent});
	};

	var refreshTimer = function() {
		$.ajax({
			headers : {
				"Content-Type" : "application/json",
				"Accept" : "application/json"
			},
			url : '/draftapp/leagues/' 
				+ lgInstanceModel.get('leagueId') 
				+ '/league-instances/' 
				+ lgInstanceModel.get('id')
				+ '/timers',
			type : 'GET',
			dataType : 'json',
			context: this,
			//accepts: 'application/json',
			//contentType: 'application/json',
			success: function(data, status) {updateTimer(data);},
		});
	};
	
	var processCometItem = function(cometItem) {
		var unescapedItem = $("<div>"+cometItem+"</div>").html();
		var jsonItem = $.parseJSON(unescapedItem);
		
		if(jsonItem.reset){
			document.location.reload();
		}
		
		//Handle Timer
		if(jsonItem.draftTimer || jsonItem.endTime){
			var timerMsg = jsonItem.draftTimer;
			if(!timerMsg){
				timerMsg = jsonItem;
			}
			
			updateTimer(timerMsg, true);
		}
		
		if(jsonItem.message){
			chatMessageCollection.add([{
				userName: jsonItem.userName, 
				dispName: jsonItem.dispName ? jsonItem.dispName : jsonItem.userName,
				message: jsonItem.message.replace(/&amp;/g, "&")}]);
		} else if(jsonItem.draftablePlayerId && jsonItem.posInRound){
			var isCustom = lgInstanceModel.get('draftType') == 'CUSTOM' ? true : false;
			var isAuction = lgInstanceModel.get('draftType') == 'AUCTION' ? true : false;
			
			if(!jsonItem.deleteAction && !jsonItem.skipAction && (!isAuction || jsonItem.value)){
				var foundPlayer = playerList.findPlayerByDraftPlayerId(jsonItem.draftablePlayerId);
				
				//Add the pick model to the pick collection
				if(isCustom){
					var pick = pickCollection.getPickByPosRound(jsonItem.round, jsonItem.posInRound);
					
					pick.set({
						id : jsonItem.id,
						leagueId : jsonItem.leagueId,
						leagueInstanceId : jsonItem.leagueInstanceId,
						fantasyTeamId : jsonItem.fantasyTeamId,
						draftablePlayerId : jsonItem.draftablePlayerId,
						draftablePlayer : foundPlayer,
						value : jsonItem.value,
						round : jsonItem.round,
						posInRound : jsonItem.posInRound,
						keeper : jsonItem.keeper,
						skipped : false,
						bid: jsonItem.bid,
						autoDrafted : jsonItem.autoDrafted
					});
				} else {
					var newPick = new PickModel({
						id : jsonItem.id,
						leagueId : jsonItem.leagueId,
						leagueInstanceId : jsonItem.leagueInstanceId,
						fantasyTeamId : jsonItem.fantasyTeamId,
						draftablePlayerId : jsonItem.draftablePlayerId,
						draftablePlayer : foundPlayer,
						value : jsonItem.value,
						round : jsonItem.round,
						posInRound : jsonItem.posInRound,
						keeper : jsonItem.keeper,
						skipped : false,
						bid: jsonItem.bid,
						autoDrafted : jsonItem.autoDrafted});	
					pickCollection.add(newPick);
				}
				
				//Auction Keepers will resync everything so don't set the cached numbers early
				if(!isAuction || lgInstanceModel.get('draftStatus') != 'PREDRAFT'){
					//subtract from budget
					//Don't think this code actually gets used.  Remove?
					if(lgInstanceModel.get('draftType') == 'AUCTION'){
						draftStatusModel.get('teamBudget')[jsonItem.fantasyTeamId] =  draftStatusModel.get('teamBudget')[jsonItem.fantasyTeamId] - jsonItem.value;
					}
					
					//Add pick to team pick list
					if(draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId] == null){
						draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId] = {};
					}
					if(draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId]['ALL_POSITIONS'] == null){
						draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId]['ALL_POSITIONS'] = [];
					}				
					draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId]['ALL_POSITIONS'].push(pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound));
					
					//Update Position Map 
					for (var i = 0; i<jsonItem.draftablePlayer.positions.length; i++) {
						var curPos = jsonItem.draftablePlayer.positions[i];
						var lgPosIdArr = lgInstanceModel.get('leaguePositions').getLgPositionsForType(curPos);
						
						if(lgPosIdArr != null){
							for (var j = 0; j < lgPosIdArr.length; j++) {
								var lgPosId = lgPosIdArr[j];
								
								if(draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId] == null){
									draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId] = {};
								}
								if(draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId][lgPosId] == null){
									draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId][lgPosId] = [];
								}
								
								draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId][lgPosId].push(pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound));
							}
						}
					}
					
					//Update Pick Count
					draftStatusModel.get('teamPickCount')[jsonItem.fantasyTeamId] = draftStatusModel.get('teamPickCount')[jsonItem.fantasyTeamId] + 1;
					
					//Recalcuate which picks the team is allowed to choose
					calcAllowedPositions(jsonItem.fantasyTeamId);
				}
				
				
				//Place pick information into the pick summary model
				var playerPos = '';
				var playerByeWeek = '';
				var playerTeamAbbr = '';
				var playerFirstName = '';
				var playerLastName = '';
				var playerId = '';
				
				if(foundPlayer){
					playerPos = foundPlayer.position;
					playerByeWeek = foundPlayer.byeWeek;
					playerTeamAbbr = foundPlayer.teamAbbr;
					playerFirstName = foundPlayer.firstName;
					playerLastName = foundPlayer.lastName;
					playerId = foundPlayer.id;
					
					foundPlayer.drafted = true;
				} else { 
					var position = '';
					for (var i = 0; i<jsonItem.draftablePlayer.positions.length; i++) {
						if(i > 0){
							position += ',';
						}
						position += jsonItem.draftablePlayer.positions[i];
					}
					//Look into this double unescape.. doesn't look right
					playerPos = position;
					playerByeWeek = jsonItem.draftablePlayer.byeWeek;
					playerTeamAbbr = jsonItem.draftablePlayer.teamAbbr;
					playerFirstName = $("<textarea/>").html($("<textarea/>").html(jsonItem.draftablePlayer.firstName).val()).val(); 
					playerLastName = $("<textarea/>").html($("<textarea/>").html(jsonItem.draftablePlayer.lastName).val()).val();
					playerId = jsonItem.draftablePlayer.id;
				}
				
				$(document).trigger('draftApp:playerPicked', playerId);
				
				//Update the summaries, and update status with bid info if it's an auction
				if(isAuction) {
					if(lgInstanceModel.get('draftStatus') == 'PREDRAFT'){
						//Picks might be moving around between pick summaries, so lets just defer to this method
						syncPicks();
					} else {
						var team = lgInstanceModel.getTeam(jsonItem.fantasyTeamId);
						
						var pickSumRound = draftStatusModel.get('teamPickCount')[jsonItem.fantasyTeamId];
						var pickSumPosInRound = team.get('draftPosition')
						
						var pickSummary = pickSummaryCollection.get(pickSummaryCollection.getPosRoundId(pickSumRound, pickSumPosInRound));
							pickSummary.set({pickId: jsonItem.id,
								keeper: jsonItem.keeper,
								autoDrafted: jsonItem.autoDrafted,
								playerPos: playerPos,
								byeWeek: playerByeWeek,
								teamAbbr: playerTeamAbbr,
								fName: playerFirstName,
								lName: playerLastName,
								fantasyTeamId : jsonItem.fantasyTeamId,
								draftablePlayerId : jsonItem.draftablePlayerId,
								auctionValue: jsonItem.value,
								auctionRound: jsonItem.round,
								auctionPosInRound: jsonItem.posInRound},{});
					}
					
					draftStatusModel.set({
						auctionBidding: false,
						auctionPickId : null,
						auctionBidPlayerId: null,
						auctionBidValue: 0,
						auctionWinningTeamId: null,
						auctionManualPlayerPos : null,
						auctionManualPlayerByeWeek : null,
						auctionManualPlayerTeamAbbr : null,
						auctionManualPlayerFirstName : null,
						auctionManualPlayerLastName : null,});
				} else {
					var pickSummary = pickSummaryCollection.get(pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound));
					
					//Get the expected posRoundId before updated the summary collection
					var curPosRoundId = pickSummaryCollection.getCurrentPosRoundId();
					
					pickSummary.set({pickId: jsonItem.id,
						keeper: jsonItem.keeper,
						skipped : false,
						autoDrafted: jsonItem.autoDrafted,
						playerPos: playerPos,
						byeWeek: playerByeWeek,
						teamAbbr: playerTeamAbbr,
						fName: playerFirstName,
						lName: playerLastName,
						fantasyTeamId : jsonItem.fantasyTeamId,
						draftablePlayerId : jsonItem.draftablePlayerId,
						auctionValue: 0,
						auctionRound: null,
						auctionPosInRound: null},{});
					
					//TODO: Check on validity of auction information too
					if(curPosRoundId != pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound) && lgInstanceModel.get('draftStatus') == 'STARTED'){
						if(prodConfig.TIMER == 'true'){
							refreshTimer();
						}
						
						updatePicks();
					}
				}
			} else if(jsonItem.deleteAction) {
				var delPick = pickCollection.get(jsonItem.id);
				
				if(delPick && isCustom){
					delPick.set({
						draftablePlayerId : 0,
						keeper : false,
						autoDrafted : false
					});
				} else if(delPick){
					pickCollection.remove(delPick);
				}
				
				//Update pos map to remove any traces of this pick
				var lgPosArr = draftStatusModel.get('teamPosMap')[jsonItem.fantasyTeamId];
				if(lgPosArr != null){
					for(var lgPosIdArr in lgPosArr) {
						var changed = false;
						for (var i = 0; i < lgPosArr[lgPosIdArr].length; i++) {
							if(lgPosArr[lgPosIdArr][i] == pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound)){
								lgPosArr[lgPosIdArr][i] = null;
								changed = true;
							}
						}
						
						if(changed){
							lgPosArr[lgPosIdArr] = _.compact(lgPosArr[lgPosIdArr]);
						}
					}
				}
				
				var isAuctionBid = false;
				
				//subtract from budget
				if(lgInstanceModel.get('draftType') == 'AUCTION' && jsonItem.value){
					draftStatusModel.get('teamBudget')[jsonItem.fantasyTeamId] =  draftStatusModel.get('teamBudget')[jsonItem.fantasyTeamId] + jsonItem.value;
				} else if(lgInstanceModel.get('draftType') == 'AUCTION' && (!jsonItem.value || jsonItem.value == 0)){
					isAuctionBid = true;
				}
				
				if(!isAuctionBid){
					//Update Pick Count
					draftStatusModel.get('teamPickCount')[jsonItem.fantasyTeamId] = draftStatusModel.get('teamPickCount')[jsonItem.fantasyTeamId] - 1;
					
					//Recalcuate which picks the team is allowed to choose
					calcAllowedPositions(jsonItem.fantasyTeamId);
				}				
				
				var delPickSummary = null;
				
				var foundPlayer = playerList.findPlayerByDraftPlayerId(jsonItem.draftablePlayerId);
				if(foundPlayer){
					foundPlayer.drafted = false;
					$(document).trigger('draftApp:playerUnpicked', foundPlayer.id);
				}
				
				if(isAuction) {
					if(lgInstanceModel.get('draftStatus') == 'PREDRAFT'){
						syncPicks();
					} else if(!isAuctionBid){
						delPickSummary = pickSummaryCollection.getAucPickByPosRoundId(pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound));
						delPickSummary.clearKeepTeam();
					}
					
					draftStatusModel.set({
						auctionBidding: false,
						auctionPickId : null,
						auctionBidPlayerId: null,
						auctionBidValue: 0,
						auctionWinningTeamId: null,
						auctionManualPlayerPos : null,
						auctionManualPlayerByeWeek : null,
						auctionManualPlayerTeamAbbr : null,
						auctionManualPlayerFirstName : null,
						auctionManualPlayerLastName : null,});
				} else {
					delPickSummary = pickSummaryCollection.get(pickSummaryCollection.getPosRoundId(jsonItem.round, jsonItem.posInRound));
					delPickSummary.clearKeepTeam();
				}
			} else if(jsonItem.skipAction) {
				
			} else if(jsonItem.draftTimer.auctionValue) {
				var position = '';
				for (var i = 0; i<jsonItem.draftablePlayer.positions.length; i++) {
					if(i > 0){
						position += ',';
					}
					position += jsonItem.draftablePlayer.positions[i];
				}
				//Look into this double unescape.. doesn't look right
				playerPos = position;
				playerByeWeek = jsonItem.draftablePlayer.byeWeek;
				playerTeamAbbr = jsonItem.draftablePlayer.teamAbbr;
				playerFirstName = $("<textarea/>").html($("<textarea/>").html(jsonItem.draftablePlayer.firstName).val()).val(); 
				playerLastName = $("<textarea/>").html($("<textarea/>").html(jsonItem.draftablePlayer.lastName).val()).val();
				playerId = jsonItem.draftablePlayer.id;
				
				draftStatusModel.set({
					auctionBidding: true,
					auctionPickId : jsonItem.id,
					auctionBidPlayerId: jsonItem.draftablePlayerId,
					auctionBidValue: jsonItem.draftTimer.auctionValue,					
					auctionWinningTeamId: jsonItem.draftTimer.auctionTeamId,
					auctionManualPlayerPos : playerPos,
					auctionManualPlayerByeWeek : playerByeWeek,
					auctionManualPlayerTeamAbbr : playerTeamAbbr,
					auctionManualPlayerFirstName : playerFirstName,
					auctionManualPlayerLastName : playerLastName,});
			}
			
			updateDraftStatus();
		}
	};
	
	var streamStatusChanged = function(state) {
		if(state == PushStream.OPEN && !refreshWait) {
			refreshWait = true;
			if(prodConfig.TIMER == 'true'){
				refreshTimer();
			}			
			updateOnlineStatus();
			updatePicks();
			setTimeout(function(){refreshWait = false;},5000);
		}
	};
	
	var enabledProdFeatures = function() {
		if(prodConfig.TIMER == 'true'){
			$('body').addClass('timer');
		}
		if(prodConfig.RANKINGS == 'true'){
			$('body').addClass('rankings');
		}
		if(prodConfig.KEEPERS == 'true'){
			$('body').addClass('keepers');
		}
		if(prodConfig.TRIAL == 'true'){
			$('body').addClass('trial');
		}
		if(prodConfig.ADS == 'false'){
			$('body').addClass('smartpeoplewilladdthis');
		}
	};
	
	/*var renderAds = function() {
		//if(prodConfig.ADS == 'true' && loginStatus.envProfile != 'development'){
		if(prodConfig.ADS == 'true'){
			
			var adsenseVarsScript   = document.createElement("script");
			adsenseVarsScript.type  = "text/javascript";
			adsenseVarsScript.text  = "google_ad_client = 'ca-pub-3997463356278504';";
			
			var extAdsenseScript   = document.createElement("script");
			extAdsenseScript.type  = "text/javascript";
			extAdsenseScript.src   = "https://pagead2.googlesyndication.com/pagead/show_ads.js";
			
			var pageWidth  = $(window).width();

			if (pageWidth >= 1400) {
				/* Leaderboard 728x90 /
				adsenseVarsScript.text  += " google_ad_slot = '7737326878';";
				adsenseVarsScript.text  += " google_ad_width = 728;";
				adsenseVarsScript.text  += " google_ad_height = 90;";
				
				document.getElementById("largeAdUnit").appendChild(adsenseVarsScript);
				document.getElementById("largeAdUnit").appendChild(extAdsenseScript);
			} else if (pageWidth >= 1200) {
				/* Banner (468 x 60) /
				adsenseVarsScript.text  += " google_ad_slot = '3167526470';";
				adsenseVarsScript.text  += " google_ad_width = 468;";
				adsenseVarsScript.text  += " google_ad_height = 60;";
				
				document.getElementById("largeAdUnit").appendChild(adsenseVarsScript);
				document.getElementById("largeAdUnit").appendChild(extAdsenseScript);
			}
		}
	};*/
	
	var marginParamProcess = function() {
		var marTop = $.isNumeric($(document).getUrlParam('margin-top')) ? parseInt($(document).getUrlParam('margin-top')) : 0;
		var marBottom = $.isNumeric($(document).getUrlParam('margin-bottom')) ? parseInt($(document).getUrlParam('margin-bottom')) : 0;
		var marLeft = $.isNumeric($(document).getUrlParam('margin-left')) ? parseInt($(document).getUrlParam('margin-left')) : 0;
		var marRight = $.isNumeric($(document).getUrlParam('margin-right')) ? parseInt($(document).getUrlParam('margin-right')) : 0;
		
		if(marTop > 0 || marBottom > 0 || marLeft > 0 || marRight > 0){
			$("body").css({
				"margin-top": marTop + "px",
				"margin-bottom": marBottom + "px",
				"margin-left": marLeft + "px",
				"margin-right": marRight + "px",});
			
			
			$("#menuFixedHeader").css("top", "+=" + marTop);
			$("#draftBoardHdrInfoContainer").css("top", "+=" + marTop);
			$("#draftBoardView .table-overflow").css("top", "+=" + marTop);
			$("#draftBoardView .table-overflow").css("bottom", "+=" + marBottom);
			$("#draftBoardView .table-overflow").css("width", $(window).width() - marLeft - marRight + "px");
			$(".fixed").css("width", $(window).width() - marLeft - marRight + "px");
			$("#footer").css("bottom", "+=" + (marBottom + marTop));
		}
	};
	
	var boardSetup = function() {		
		updateDraftedPlayers();
		
		queueCollection.loadData(playerList);
		headerView.loadPlayerList(playerList);
		
		var selectPlayerView = new SelectPlayerView({
				user: userModel,
				pickCollection: pickCollection,
				pickSummaryCollection: pickSummaryCollection,
				playerList: playerList,
				leagueInstance: lgInstanceModel,
				posColors: positionColorsModel,
				draftStatus: draftStatusModel,
				sportsTeams: sportsTeams
			});
		var viewModeView = new DraftViewModeView({leagueInst: lgInstanceModel, userModel: userModel});
		var playerRanksView = new PlayerRanksView({
			userModel: userModel,
			pickSummaryCollection: pickSummaryCollection,
			playerList: playerList,
			leagueInstance: lgInstanceModel,
			draftStatus: draftStatusModel,
			posColors: positionColorsModel,
			prodConfig: prodConfig,
			queueCollection: queueCollection,
			sportsTeams: sportsTeams
		});
		
		selectPlayerView.render();
		viewModeView.render();
		playerRanksView.render();
				
		//Update online status every now and then
		setInterval(serverCheckin,55000);  //55s
		
		var lastTime = (new Date()).getTime();
		setInterval(function() {
			var currentTime = (new Date()).getTime();
			if (currentTime > (lastTime + 1000*2) && !refreshWait) {  // ignore small delays
				refreshWait = true;
				if(prodConfig.TIMER == 'true'){
					refreshTimer();
				}
				updateOnlineStatus();
				updatePicks();
				setTimeout(function(){refreshWait = false;},1000);
			}
			lastTime = currentTime;						
			
			if(pushstream.readyState == PushStream.CLOSED && lgInstanceModel.get('draftStatus') != 'COMPLETED' && !reconnectWait){
				reconnectWait = true;
				pushstream.connect();
				setTimeout(function(){reconnectWait = false;},4000);
			}
		}, 1000);
		
		$(document).trigger('draftApp:loadingComplete');
	};
	
	var initialize = function(){
		$(document).keydown(function(event){
			if(event.keyCode == 13) {
				event.preventDefault();
				return false;
			}
		});
		
		var initialModels = KnownUtil.setupCollapsibleSideNav();
		var prodCollection = initialModels.prodCollection;
		var loginStatus = $.parseJSON(module.config().requestedLoginStatusJSON);
		
		//Setup common vars
		serverTimeDiff = (new Date()).getTime() - loginStatus.serverTime;
		prodConfig = $.parseJSON(module.config().requestedProdConfigJSON);
		
		enabledProdFeatures();
		marginParamProcess();		
		
		userModel = initialModels.userModel;
		lgInstanceModel = LeagueInstanceModel.findOrCreate($.parseJSON(module.config().requestedLgInstJSON));
		//if(if(userModel.get('userName') == 'CLICKYUSER'){
		//	
		//}
		chatMessageCollection = new ChatMessageCollection([], {});
		pickSummaryCollection = new PickSummaryCollection([], {lgInst: lgInstanceModel});
		var unescapedPicks = $("<div>"+module.config().requestedPicksJSON+"</div>").html();
		pickCollection = new PickCollection($.parseJSON(unescapedPicks), {
			leagueInstanceId: lgInstanceModel.get('id'), 
			leagueId: lgInstanceModel.get('leagueId')});
		draftStatusModel = new DraftStatusModel({
				id: lgInstanceModel.get('id'),
				posInRound: 1,
				draftingTeamId: lgInstanceModel.getTeamByDraftPosition(1).get('id'), 
				round: 1,
				draftType: lgInstanceModel.get('draftType'),
				completed: false,
				demo: false,
				auctionBidding: false,
				auctionPickId: null,
				auctionBidPlayerId: null,
				auctionWinningTeamId: null,
				auctionBidValue: 0,
				auctionManualPlayerPos : null,
				auctionManualPlayerByeWeek : null,
				auctionManualPlayerTeamAbbr : null,
				auctionManualPlayerFirstName : null,
				auctionManualPlayerLastName : null,});
		
		calcTeamMaxNumPicks();
		
		positionColorsModel = new PositionColorsModel({}, {
			lgInstId: lgInstanceModel.get('id'),
			lgPosCollection: lgInstanceModel.get('leaguePositions')});
		
		var requestedProdJSON = $.parseJSON(module.config().requestedProdJSON);
		prodModel = prodCollection.retrieveProdWithProdTypeId(requestedProdJSON.productTypes[0].id);
		if(!prodModel){
			prodModel = ProductModel.findOrCreate(requestedProdJSON);
		}
		
		//Setup timer and update it if one exists
		timerModel = new TimerModel({
				isActive: false,
				auctionTeamId: null,
				auctionValue: null,
				endTime: null,
				duration: 1000 * lgInstanceModel.get('timerDuration') + 999, //Default it to timerDuration plus .999 seconds
				pauseTimeRemaining: null,
				serverTimeDiff: serverTimeDiff});
		
		var foundTimer = lgInstanceModel.get('draftTimer');
		if(foundTimer){
			timerModel.set({
				isActive: foundTimer.active,
				endTime: foundTimer.endTime,
				duration: foundTimer.duration,
				pauseTimeRemaining: foundTimer.pauseTimeRemaining,
			});
			
			if(lgInstanceModel.get('draftType') == 'AUCTION') {
				//TODO: We need to set a default timer if there has been a nomination, but the cached timer expired
				//It will need a default value of 1 and the nominating team will need to be found
				//Also might need some server side changes as well
				draftStatusModel.set({
					auctionBidValue: foundTimer.auctionValue,
					auctionWinningTeamId: (foundTimer.auctionTeamId ? foundTimer.auctionTeamId : null)});
			}
			
		}
		
		//Setup initial pick summary data
		var ovrPickNum = 1;
		for (var curRound = 1; curRound <= lgInstanceModel.get('numRounds'); curRound++) {
			if(lgInstanceModel.get('draftType') == 'CUSTOM'){
				var foundPicksInRound = pickCollection.getPicksByRound(curRound);
				var picksInRound = _.sortBy(foundPicksInRound, function(pick){ return pick.getPosRoundSortValue(); }, this);
				
				_.each(picksInRound, function(pick, i){
					var pickSummaryModel = new PickSummaryModel({
						id: pickSummaryCollection.getPosRoundId(pick.get('round'), pick.get('posInRound')),
						fantasyTeamId: pick.get('fantasyTeamId'),
						round: pick.get('round'),
						posInRound: pick.get('posInRound'),
						ovrPickNum: ovrPickNum});
					pickSummaryCollection.add(pickSummaryModel);
					ovrPickNum++;
				}, this);
			} else {
				for(var i = 1; i <= lgInstanceModel.numTeams(); i++){
					var tmDraftPos = i;
					var isSnake = lgInstanceModel.get('draftType') == 'SNAKE' ? true : false;
					
					if(curRound % 2 == 0 && isSnake){
						tmDraftPos = lgInstanceModel.numTeams() - (tmDraftPos - 1);
					}
					
					var pickSummaryModel = new PickSummaryModel({
						id: pickSummaryCollection.getPosRoundId(curRound, i), 
						fantasyTeamId: lgInstanceModel.getTeamByDraftPosition(tmDraftPos).get('id'),
						round: curRound,
						posInRound: i,
						ovrPickNum: ovrPickNum});
					pickSummaryCollection.add(pickSummaryModel);
					ovrPickNum++;
				}
			}			
		}
		
		loadPicks();
		
		draftOptionsModel = new DraftOptionsModel({},{lgInst: lgInstanceModel ,numTeams: lgInstanceModel.numTeams()});
		//draftOptionsModel.initializeWidth();
		
		//Update the draft status
		updateDraftStatus();
		
		//Update the online status of all the users
		var onlineStatus = $.parseJSON(module.config().requestedProdConfigJSON);
		_.each(onlineStatus.userOnlineStatusMap, function(statusObj, name){
			lgInstanceModel.getLeagueUser(name).set({
				timeSinceActivity : statusObj.timeSinceActivity,
				activityTime : statusObj.activityTime
			});
		}, this);
		
		queueCollection = new QueueCollection([], {lgInstId: lgInstanceModel.get('id')});
		rosterPositionCollection = new RosterPositionCollection([], {
			leagueInst: lgInstanceModel,
			draftStatusModel: draftStatusModel,
			pickSummaries: pickSummaryCollection
		});
		rosterPositionCollection.initCollectionData();
		
		//Initialize the streaming to be used for comet
		//var loadBalancedCometServer = (lgInstanceModel.get('id') % 2) + 1;
		var loadBalancedCometServer = 1;
		var hostName = 'stream' + loadBalancedCometServer + '.clickydraft.com';
		
		if(loginStatus.envProfile && loginStatus.envProfile == 'development'){
			hostName = window.location.hostname;
		}
		
		pushstream = new PushStream({
			host: hostName, 
			port: window.location.port,
			useSSL: true,
			modes: "websocket|stream|longpolling"});
			//modes: "eventsource|stream|longpolling"});
		pushstream.onmessage = processCometItem;
		pushstream.onstatuschange = streamStatusChanged;
		pushstream.addChannel(lgInstanceModel.get('id').toString());
		pushstream.connect();
		
		var chatView = new ChatView({
				chatMessageCollection: chatMessageCollection,
				userModel: userModel,
				leagueModel: lgInstanceModel,
				draftStatusModel: draftStatusModel});
		
		var delPickView = new DeletePickView({
			lgInst: lgInstanceModel,
			pickSummaryCollection: pickSummaryCollection,
			pickCollection: pickCollection});
		
		var draftBoardView = new DraftBoardView({
			leagueInst: lgInstanceModel,
			user: userModel,
			pickSummaryCollection: pickSummaryCollection,
			draftOptions: draftOptionsModel,
			posColors: positionColorsModel,
			prodConfig: prodConfig,
			pickCollection: pickCollection,
			draftStatusModel: draftStatusModel});
		
		var teamRosterView = new TeamRosterView({
			leagueInst: lgInstanceModel,
			user: userModel,
			pickSummaryCollection: pickSummaryCollection,
			draftOptions: draftOptionsModel,
			posColors: positionColorsModel,
			draftStatusModel: draftStatusModel,
			rosterPositionCollection: rosterPositionCollection});
		
		headerView = new HeaderView({
			timerModel: timerModel,
			lgInstanceModel: lgInstanceModel,
			userModel: userModel,
			pickSummaryCollection: pickSummaryCollection,
			draftStatusModel: draftStatusModel,
			posColors: positionColorsModel,
			prodConfig: prodConfig,
			pickCollection: pickCollection});
		
		var queueView = new QueueView({
			leagueInstance: lgInstanceModel,
			userModel: userModel,
			pickSummaryCollection: pickSummaryCollection,
			draftStatus: draftStatusModel,
			posColors: positionColorsModel,
			queueCollection: queueCollection});
		
		var draftInfoView = new DraftInfoView({
			leagueInst: lgInstanceModel,
			pickSummaryCollection: pickSummaryCollection,
			draftStatus: draftStatusModel,
			posColors: positionColorsModel,
			pickCollection: pickCollection,
			rosterPositionCollection: rosterPositionCollection});
		
		var optionView = new OptionView({
			lgInst: lgInstanceModel, 
			draftOptions: draftOptionsModel, 
			posColors: positionColorsModel,
			userModel: userModel});
		var shareView = new ShareView({lgInstanceModel: lgInstanceModel});
		
		//Allow users to click some dropdown menus without it closing (chat & options)
		$(document).on('click.dropdown.data-api', '.downdownDisplayContent', function (e) { e.stopPropagation(); });
		
		chatView.render();
		delPickView.render();
		optionView.render();
		shareView.render();
		headerView.render();
		draftBoardView.render();	
		teamRosterView.render();
		queueView.render();
		draftInfoView.render();
		
		sportsTeams = $.parseJSON(module.config().requestedSportTeamsJSON);
		
		//Retrieve list of draftable players
		$.ajax({
			headers : {
				"Content-Type" : "application/json",
				"Accept" : "application/json"
			},
			url : '/draftapp/leagues/' 
				+ lgInstanceModel.get('leagueId') 
				+ '/league-instances/' 
				+ lgInstanceModel.get('id')
				+ '/draftable-players',
			type : 'GET',
			dataType : 'json',
			context:this,
			success: function(data, status) {
    			playerList = new PlayerList(data,lgInstanceModel.get('leagueId'),lgInstanceModel.get('id'));
				boardSetup();
			}
		});
	};
	
	return {
		initialize: initialize
	};
});